export default __webpack_public_path__ + "static/game-image-1-ita-e586e0e6f87b96e94eacf11a30ac1cee.png";